import { AppService, AppTypes } from 'st-app/Services/AppService';
import { CommonIdentityTypes } from 'st-common/Identity/CommonIdentityTypes';

const Types = {
    ...AppTypes,
    Identity: CommonIdentityTypes
}

export { AppService, Types }
